const initialState = {
  date: null,
};

const currentDate = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_LABELS_CURRENT_DATE':
      return {
        ...state,
        date: action.date,
      };

    default:
      return state;
  }
};

export default currentDate;

export const getCurrentDate = (state) => state.date;
